export const translations = {
  pt: {
    brand: "ANGOLAUK+",
    tagline: "A nossa gente. Sempre mais perto.",
    hero_title: "Encontra a tua comunidade angolana no Reino Unido",
    hero_sub: "Pessoas, eventos, negócios e oportunidades perto de ti.",
    city_placeholder: "Em que cidade estás?",
    search: "Pesquisar",
    community: "Comunidade",
    events: "Eventos",
    restaurants: "Restaurantes",
    businesses: "Negócios & Serviços",
    marketplace: "Marketplace",
    jobs: "Empregos",
    classifieds: "Classificados",
    featured_events: "Eventos em destaque",
    discover_marketplace: "Descobre no Marketplace",
    featured_businesses: "Negócios em destaque",
    popular_communities: "Comunidades populares",
    home: "Início",
    explore: "Explorar",
    feed: "Feed",
    feed_for_you: "Para ti",
    feed_recent: "Recentes",
    feed_communities: "Comunidades",
    feed_empty: "Ainda não há publicações. Sê o primeiro a partilhar algo no teu perfil ou numa comunidade.",
    feed_more: "Ver mais",
    feed_end: "Chegaste ao fim",
    home_explore_title: "Explorar",
    home_explore_sub: "Descobre pessoas, negócios e muito mais",
    search_label: "Procura comunidades e negócios na tua cidade",
    quick_links: "Atalhos",
    businesses: "Negócios",
    categories: "Categorias",
    community_sub: "Grupos, conversas e ajuda",
    events_sub: "O que vai acontecer perto de ti",
    marketplace_sub: "Compra e vende na comunidade",
    restaurants_sub: "Sabores de Angola no UK",
    jobs_sub: "Vagas e oportunidades",
    classifieds_sub: "Anuncia e encontra",
    nearby_businesses: "Negócios da comunidade",
    members: "membros",
    community_activity: "Publicações recentes",
    activity_login_title: "Entra para ver as publicações",
    activity_login_sub: "Publicações recentes de pessoas e comunidades angolanas no UK",
    see_feed: "Ver o Feed",
    empty_offers: "Sem ofertas ainda",
    not_found_title: "Página não encontrada",
    not_found_body: "O link pode estar errado ou a página já não existe.",
    back_home: "Voltar ao Início",
    go_explore: "Explorar",
    verify_title: "Confirma o teu e-mail",
    verify_body: "Para publicar, comentar e enviar mensagens, confirma o e-mail que enviámos para",
    verify_help: "Verifica também a pasta de spam. Endereço errado? Contacta support@angolauk.co.uk.",
    verify_check: "Já confirmei",
    verify_resend: "Reenviar e-mail",
    verify_sent: "E-mail de confirmação enviado.",
    verify_already: "O teu e-mail já está confirmado.",
    verify_done: "E-mail confirmado!",
    verify_not_yet: "Ainda não confirmado. Abre o link no e-mail.",
    verify_error: "Não foi possível enviar. Tenta novamente.",
    verify_banner: "Confirma o teu e-mail para publicar e enviar mensagens.",
    verify_loading: "A confirmar o teu e-mail…",
    verify_success_body: "Já podes publicar, comentar e enviar mensagens no ANGOLAUK+.",
    verify_continue: "Continuar",
    verify_invalid_title: "Link inválido ou expirado",
    verify_invalid_body: "Este link já foi utilizado, expirou (24 h) ou nunca foi válido. Pede um novo e-mail de confirmação.",
    verify_status_ok: "E-mail confirmado",
    verify_status_pending: "E-mail por confirmar",
    register_done_verify: "Conta criada! Enviámos um e-mail para confirmares o teu endereço.",
    publish: "Publicar",
    messages: "Mensagens",
    profile: "Perfil",
    login: "Entrar",
    register: "Criar conta",
    logout: "Sair",
    see_all: "Ver todos",
    all_cities: "Todas as cidades",
    all_categories: "Todas",
    members: "membros",
    member_one: "membro", member_other: "membros", post_one: "publicação", post_other: "publicações",
    add_business: "Adicionar o meu negócio",
    publish_event: "Publicar um evento",
    publish_job: "Publicar vaga",
    publish_classified: "Publicar anúncio",
    demo: "Demo",
    disclaimer: "Plataforma independente. Não afiliada ao governo angolano nem a qualquer partido político.",
  },
  en: {
    brand: "ANGOLAUK+",
    tagline: "Our people. Always closer.",
    hero_title: "Find your Angolan community in the United Kingdom",
    hero_sub: "People, events, businesses and opportunities near you.",
    city_placeholder: "Which city are you in?",
    search: "Search",
    community: "Community",
    events: "Events",
    restaurants: "Restaurants",
    businesses: "Businesses & Services",
    marketplace: "Marketplace",
    jobs: "Jobs",
    classifieds: "Classifieds",
    featured_events: "Featured events",
    discover_marketplace: "Discover the Marketplace",
    featured_businesses: "Featured businesses",
    popular_communities: "Popular communities",
    home: "Home",
    explore: "Explore",
    feed: "Feed",
    feed_for_you: "For you",
    feed_recent: "Recent",
    feed_communities: "Communities",
    feed_empty: "No posts yet. Be the first to share something on your profile or in a community.",
    feed_more: "Load more",
    feed_end: "You're all caught up",
    home_explore_title: "Explore",
    home_explore_sub: "Discover people, businesses and more",
    search_label: "Find communities and businesses in your city",
    quick_links: "Shortcuts",
    businesses: "Businesses",
    categories: "Categories",
    community_sub: "Groups, chats and support",
    events_sub: "What's happening near you",
    marketplace_sub: "Buy and sell in the community",
    restaurants_sub: "Angolan flavours in the UK",
    jobs_sub: "Vacancies and opportunities",
    classifieds_sub: "Post and find",
    nearby_businesses: "Community businesses",
    members: "members",
    community_activity: "Recent posts",
    activity_login_title: "Sign in to see recent posts",
    activity_login_sub: "Recent posts from Angolan people and communities in the UK",
    see_feed: "Open the Feed",
    empty_offers: "No offers yet",
    not_found_title: "Page not found",
    not_found_body: "The link may be wrong or the page no longer exists.",
    back_home: "Back to Home",
    go_explore: "Explore",
    verify_title: "Confirm your e-mail",
    verify_body: "To post, comment and send messages, confirm the e-mail we sent to",
    verify_help: "Check your spam folder too. Wrong address? Contact support@angolauk.co.uk.",
    verify_check: "I've confirmed",
    verify_resend: "Resend e-mail",
    verify_sent: "Confirmation e-mail sent.",
    verify_already: "Your e-mail is already confirmed.",
    verify_done: "E-mail confirmed!",
    verify_not_yet: "Not confirmed yet. Open the link in the e-mail.",
    verify_error: "Could not send. Please try again.",
    verify_banner: "Confirm your e-mail to post and send messages.",
    verify_loading: "Confirming your e-mail…",
    verify_success_body: "You can now post, comment and send messages on ANGOLAUK+.",
    verify_continue: "Continue",
    verify_invalid_title: "Invalid or expired link",
    verify_invalid_body: "This link was already used, expired (24 h) or was never valid. Request a new confirmation e-mail.",
    verify_status_ok: "E-mail confirmed",
    verify_status_pending: "E-mail not confirmed",
    register_done_verify: "Account created! We sent you an e-mail to confirm your address.",
    publish: "Publish",
    messages: "Messages",
    profile: "Profile",
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
    see_all: "See all",
    all_cities: "All cities",
    all_categories: "All",
    members: "members",
    member_one: "member", member_other: "members", post_one: "post", post_other: "posts",
    add_business: "Add my business",
    publish_event: "Publish event",
    publish_job: "Post a job",
    publish_classified: "Post ad",
    demo: "Demo",
    disclaimer: "Independent platform. Not affiliated with the Angolan government or any political party.",
  },
};

export const BUSINESS_CATEGORIES = [
  "Restaurantes & Catering", "Cabelo & Beleza", "Moda", "Transporte",
  "Fotografia & Vídeo", "Contabilidade", "Serviços Jurídicos",
  "Interpretação", "Construção", "Produtos Angolanos", "Outros",
];

export const EVENT_CATEGORIES = [
  "Festas", "Cultura", "Comunidade", "Família", "Networking", "Música", "Workshops",
];

export const JOB_CATEGORIES = [
  "Restauração", "Beleza", "Transporte", "Contabilidade", "Retalho", "Construção",
  "Saúde", "Educação", "Tecnologia", "Outros",
];

export const CLASSIFIED_CATEGORIES = [
  { id: "rooms", label_pt: "Quartos & Imóveis", label_en: "Rooms & Property" },
  { id: "services", label_pt: "Serviços", label_en: "Services" },
  { id: "items", label_pt: "Artigos à venda", label_en: "Items for sale" },
];

export const INTERESTS = [
  "Música", "Culinária", "Desporto", "Cinema", "Livros", "Dança",
  "Viagens", "Fotografia", "Empreendedorismo", "Família",
];

export const LOOKING_FOR = [
  "Comunidade", "Amizade", "Networking", "Negócios", "Eventos", "Família",
];

export const ANGOLA_PROVINCES = [
  "Luanda", "Benguela", "Huambo", "Huíla", "Bié", "Cabinda", "Cuando Cubango",
  "Cuanza Norte", "Cuanza Sul", "Cunene", "Lunda Norte", "Lunda Sul",
  "Malanje", "Moxico", "Namibe", "Uíge", "Zaire", "Bengo",
];
